module.exports = __webpack_public_path__ + "static/media/classes.8491c2f5.svg";